import React, {  useEffect, useState } from "react";
import CreateIcon from '@mui/icons-material/Create';
import PredecessorPopup from "./PredecessorPopupContent";
import { getIndexesFromNodeArray } from "../../helper/helpersSubModule";
import { Tooltip, Typography, tooltipClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { checkForEmptyNotes } from "../../helper/helpersSubModule";
import { applyStylestoCellRenderer } from "../../helper/helperFunctions";

const ArrowIcon = styled(ArrowDropDownIcon)`
  position: absolute;
  top: 2px;
  right: 22px;
  color: #3fd237;
  font-size: 28px;
  transform: rotate(225deg);
  transform-origin: top right;
`;

const LightTooltip = styled(({ className, children, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }}
        PopperProps={{
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [-20, 0], // Move the tooltip slightly to the left or adjust as needed
                    },
                },
            ],
        }}
    >
        <span>
            {children}
        </span>
    </Tooltip>
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: '11px',
        fontWeight: 'bold',
    },
}));


export const CustomPredecessorRenderer = ({ params, updateRowDHelper,isOwner, readOnlyMode, sheetType}) => {
    const value= params.value
    let { node, column, eGridCell,colDef,data } = params
    const [open, setOpen] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        const checkFocus = () => {
          const focusedCell = params.api.getFocusedCell();
      
          setIsFocused(
            focusedCell &&
            focusedCell.rowIndex === params.node.rowIndex &&
            focusedCell?.column?.getColId() === params?.column?.getColId()
          );
        };
      
        checkFocus();
      
        params.api.addEventListener('cellFocused', checkFocus);
      
        return () => {
          params.api.removeEventListener('cellFocused', checkFocus);
        };
      }, [params]);

      
    const handleClick = (e) => {
        if (sheetType === 'filterSheet') {
            setOpen(false);
        } else if (isOwner || !readOnlyMode) {
            setOpen(true);
        }
    }
    let {indexString,primaryColValue}=getIndexesFromNodeArray(value,params)
    let columnName=params.colDef.field+"_es"
    let cellFormatting=params.data ? params.data[columnName]?.cellStyle:{}

        let cellFormat = data ? data[columnName]?.format : '';

    const cellStyle = applyStylestoCellRenderer(cellFormat); // Get dynamic text styles

    return (
        <div style={{...cellStyle,  width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row', fontSize: cellFormatting?.fontSize || '12px', color: cellFormatting?.color || "black", alignItems: 'center', fontFamily: cellFormatting?.fontFamily || "Arial" }}
            onKeyDown={()=>{
                if(!open){
                    params.api.startEditingCell({
                        rowIndex: node.rowIndex,
                        colKey: column
                    })};
        }}>
            <span>{indexString}</span>
            
            {isFocused &&
                (params.node.allChildrenCount === 0 || params.node.allChildrenCount === undefined || params.node.allChildrenCount === null) && (primaryColValue?.length > 0 ? (
                    <LightTooltip title={<Typography style={{ fontSize: '11px', fontWeight: 'bold' }}>Predecessor: {primaryColValue}</Typography>} placement="bottom-end">
                        {!readOnlyMode && !params?.node?.data?.checkinagent && !params?.node?.data?.isAzureRow && params.colDef.editable !== false && sheetType !== 'filterSheet' &&
                            <CreateIcon className="predecessor-popup-opener-icon" onClick={(e) => {
                                e.stopPropagation();
                                handleClick(e);
                            }} sx={{
                                fontSize: "1rem", color: "#134157",
                                pointerEvents: "auto"
                            }} />}
                    </LightTooltip>
                ) : (
                    !readOnlyMode && !params?.node?.data?.checkinagent && !params?.node?.data?.isAzureRow && params.colDef.editable !== false && sheetType !== 'filterSheet' &&
                    <CreateIcon className="predecessor-popup-opener-icon" onClick={(e) => {
                        e.stopPropagation();
                        handleClick(e);
                    }} sx={{
                        fontSize: "1rem", color: "#134157",
                        pointerEvents: "auto"
                    }} />
                ))}
            
            {open &&  <PredecessorPopup open={open} setOpen={setOpen} value={value} params={params} updateRowDHelper={updateRowDHelper}/>}
            {params?.colDef?.field && params?.data?.hasOwnProperty(params?.colDef?.field+'_es') && params?.data[params?.colDef?.field + "_es"]!==undefined && !checkForEmptyNotes(params?.data[params.colDef.field + "_es"]?.notes) &&
                    <ArrowIcon onClick={(e) => { if(!readOnlyMode){params.onClickOpenRightDrawer("notes", 0); }}} />
                }
        </div>
    );
}